/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, files: NonNullable<unknown> }} Presentation_Template_Drop_RejectedInputs */



/**
* | output |
* | --- |
* | "{count} file(s) skipped — a template must be a PowerPoint template (.potx, .pptx or .pptm). Skipped: {files}" |
*
* @param {Presentation_Template_Drop_RejectedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_template_drop_rejected = /** @type {((inputs: Presentation_Template_Drop_RejectedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Template_Drop_RejectedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Datei(en) übersprungen – eine Vorlage muss eine PowerPoint-Vorlage sein (.potx, .pptx oder .pptm). Übersprungen: ${i?.files}`)
	return /** @type {LocalizedString} */ (`${i?.count} file(s) skipped — a template must be a PowerPoint template (.potx, .pptx or .pptm). Skipped: ${i?.files}`)
});